/**
 * Date utilities that avoid UTC/local timezone mismatches.
 * JavaScript's `new Date("YYYY-MM-DD")` parses as UTC midnight,
 * which shifts to the previous day in western timezones (e.g., Colombia UTC-5).
 * These helpers always use LOCAL time.
 */

/** Returns today's local date as "YYYY-MM-DD" */
export function getLocalToday() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/** Adds/subtracts days from a "YYYY-MM-DD" string, returns "YYYY-MM-DD" in local time */
export function addDaysLocal(dateStr, days) {
    const [y, m, d] = dateStr.split('-').map(Number);
    const result = new Date(y, m - 1, d + days);
    return `${result.getFullYear()}-${String(result.getMonth() + 1).padStart(2, '0')}-${String(result.getDate()).padStart(2, '0')}`;
}

/** Parses "YYYY-MM-DD" as a local Date object (not UTC) */
export function parseLocalDate(dateStr) {
    const [y, m, d] = dateStr.split('-').map(Number);
    return new Date(y, m - 1, d);
}

/** Returns first day of current month as "YYYY-MM-DD" */
export function getLocalMonthStart() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`;
}
